export default __webpack_public_path__ + "static/media/singulare.1bbd1a3f.png";